import {Typography, useTheme} from '@mui/material';
import Grid from '@mui/material/Grid';
import {styled} from '@mui/material/styles';
import {ClockIcon} from '@mui/x-date-pickers';

import {REPORT_UPDATE_HISTORY_STATUSES} from '../../../../../const';
import {reportSingleUpdateHistoryShape} from '../../../../../proptypes-shapes';
import {formatDuration, getHumanReadableTimeElapsedFromDate} from '../../../../../utils';
import CategoryAccordionIcon from '../../../shared/CategoryAccordionIcon/CategoryAccordionIcon';
import ComplementaryInformation from '../ComplementaryInformation/ComplementaryInformation';
import FailedUpdateHistory from '../FailedUpdateHistory/FailedUpdateHistory';
import HistoryTitle from '../HistoryTitle/HistoryTitle';
import SingleUpdateHistoryBlockContainer from '../SingleUpdateHistoryBlockContainer/SingleUpdateHistoryBlockContainer';
import SuccessfulUpdateHistory from '../SuccessfulUpdateHistory/SuccessfulUpdateHistory';

const Subtitle = styled(Typography)({
  fontSize: 13,
  color: 'grey',
  marginBottom: theme => theme.spacing(1)
});

const getUpdateHistoryStatusConfig = muiTheme => ({
  [REPORT_UPDATE_HISTORY_STATUSES.COMPLETED]: {
    title: 'Actualisation réussie',
    icon: 'Check',
    iconColor: muiTheme.palette.success.main,
    backgroundColor: 'white',
    borderColor: '#DEDEDE'
  },
  [REPORT_UPDATE_HISTORY_STATUSES.FAILED]: {
    title: 'Actualisation échouée',
    icon: 'Error',
    iconColor: '#c98a04',
    backgroundColor: '#FEFCEA',
    borderColor: '#FDE68A'
  },
  [REPORT_UPDATE_HISTORY_STATUSES.CANCELLED]: {
    title: 'Actualisation annulée',
    icon: 'Cancel',
    iconColor: '#c98a04',
    backgroundColor: '#FEFCEA',
    borderColor: '#FDE68A'
  }
});

// eslint-disable-next-line complexity
const SingleUpdateHistoryBlock = ({history}) => {
  const theme = useTheme();
  const statusConfig = getUpdateHistoryStatusConfig(theme)[history.status];

  if (!statusConfig) return null;

  const {title, icon, iconColor, backgroundColor, borderColor} = statusConfig;

  return (
    <SingleUpdateHistoryBlockContainer
      sx={{
        backgroundColor,
        border: `1px solid ${borderColor}`
      }}
    >
      <Grid
        container
        gap={2}
        p={{
          xs: 1,
          sm: 2
        }}
      >
        <Grid item>
          <CategoryAccordionIcon iconName={icon} color={iconColor} />
        </Grid>

        <Grid item flex={1}>
          <HistoryTitle>{title}</HistoryTitle>

          {history.message && <Subtitle>{history.message}</Subtitle>}

          <Grid container gap={2} alignItems="center" mt={0.5}>
            <Grid item>
              <Grid container gap={0.5} alignItems="center">
                <ClockIcon sx={{fontSize: 14, color: iconColor}} />
                <ComplementaryInformation>Durée: {formatDuration(history.startTime, history.endTime)}</ComplementaryInformation>
              </Grid>
            </Grid>

            {history.status === REPORT_UPDATE_HISTORY_STATUSES.FAILED && <FailedUpdateHistory history={history} iconColor={iconColor} />}

            {history.status === REPORT_UPDATE_HISTORY_STATUSES.COMPLETED && <SuccessfulUpdateHistory iconColor={iconColor} tables={history.objects} />}
          </Grid>
        </Grid>

        <Grid item>
          <Typography fontSize={13} color="text.secondary">
            {getHumanReadableTimeElapsedFromDate(history.endTime)}
          </Typography>
        </Grid>
      </Grid>
    </SingleUpdateHistoryBlockContainer>
  );
};

SingleUpdateHistoryBlock.propTypes = {
  history: reportSingleUpdateHistoryShape.isRequired
};

export default SingleUpdateHistoryBlock;
